import styled from 'styled-components';

export const CertificateContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.l};
  justify-content: space-between;
  padding: 2rem 0;
  animation: fadeIn 0.8s;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const EachCertificate = styled.div`
  background: ${({ theme }) => theme.colors.offWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow3};
  width: 360px;
  padding: 1.5rem 1.2rem 1.2rem 1.2rem;
  margin-bottom: 1.5rem;
  transition:
    box-shadow 0.3s,
    transform 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.shadow5};
    transform: translateY(-8px) scale(1.03);
  }
  h4 {
    color: ${({ theme }) => theme.colors.orange5};
    margin-bottom: 0.7rem;
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: 0.03em;
  }
  p {
    color: ${({ theme }) => theme.colors.grey6};
    margin-bottom: 0.4rem;
    font-size: 1rem;
    &:last-child {
      /* color: ${({ theme }) => theme.colors.yellow5}; */
      font-weight: 600;
    }
  }
  iframe {
    width: 100%;
    height: 230px;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid ${({ theme }) => theme.colors.grey2};
    margin-top: 1rem;
    background: ${({ theme }) => theme.colors.grey1};
    box-shadow: 0 1px 6px #0001;
  }
`;
